'use client';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { useMemo } from 'react';

import { type EntryComponentProps } from '@/utils/contentful/schema/EntryComponentProps';

import { ProgressButton } from './ProgressButton';
import { type progressButtonSchema } from './progressButtonSchema';
import { useFlowProgressButtonState } from './useFlowProgressButtonState';
import { useNavigation } from '../../hooks/useNavigation';

type ProgressButtonContentfulProps = EntryComponentProps<
  typeof progressButtonSchema,
  unknown
>;

export const ProgressButtonContentful = ({
  entry: { label, direction, type },
}: ProgressButtonContentfulProps) => {
  const { onBack, onNext, canNavigateBack } = useNavigation();

  const buttonProps = useFlowProgressButtonState(
    {
      forward: onNext,
      back: onBack,
    }[direction],
  );

  const children = useMemo(
    () =>
      documentToReactComponents(label, {
        renderNode: {
          [BLOCKS.PARAGRAPH]: (node, children) => children,
        },
      }),
    [label],
  );

  if (direction === 'back' && !canNavigateBack) {
    return null;
  }

  return (
    <ProgressButton buttonType={type} {...buttonProps}>
      {children}
    </ProgressButton>
  );
};
